function init() {
  const isValidURL = (url) => {
    if (!url) return false;
    if (url === '#' || url === 'javascript:void(0)') return false;
    if (!/^https?:\/\//i.test(url)) return false;
    return true;
  };

  document.addEventListener(
    'click',
    function (e) {
      const a = e.target.closest('a[target="_blank"]');
      if (!a) return;

      const href = (a.getAttribute('href') || '').trim();

      if (!isValidURL(href)) {
        e.preventDefault();
        e.stopImmediatePropagation();

        console.warn(
          '[SECURITY] Lien bloqué : URL non valide ou vide →',
          href || '(vide)'
        );
        return false;
      }
    },
    true
  );

  const nativeOpen = window.open;

  window.open = function (url, target, features) {
    if (target === '_blank') {
      const clean = (url || '').trim();

      if (!isValidURL(clean)) {
        console.warn('[ANTI-LEAK] window.open bloqué →', clean || '(vide)');
        return null;
      }
    }

    return nativeOpen.apply(window, arguments);
  };
}

init();
